export enum IntegrationModes {
  STANDALONE = 'standalone',
  EMBEDDED = 'embedded',
  WCS = 'wcs',
}

export const isEmbeddedIntegrationMode = (integrationMode?: string) =>
  integrationMode === IntegrationModes.EMBEDDED ||
  integrationMode === IntegrationModes.WCS;
